import axios from "axios";
import { useMutation, useQuery } from "react-query";

/**
 * Display link preview
 * @param {string} url
 * @param {Object} [reactQuery]
 */
export default function useDisplayLinkPreview(url, reactQuery = {}) {
    return useQuery(
        reactQuery?.key || ["linkPreview", url],
        async () => (await axios.post("/link-preview", { url }))?.data,
        {
            ...reactQuery?.options,
        }
    );
}

/**
 * Send a message for sync AI chatbot
 * @param {Object} [reactQuery]
 */
export function useSendMessageSyncMutation(reactQuery) {
    return useMutation(
        async (message) => (await axios.post("/message-sync", message)).data,
        reactQuery
    );
}
